$('.header__heading .desk-top a').on('click', function(){
  $('.header__heading .desk-top.current').removeClass('current');
  $(this).parents('.desk-top').addClass('current');
});
//FAQ
$('.faq-que-ans .faq-que').click(function(){
  $('.faq-que-ans').not($(this).parent()).removeClass('active');
  $(this).parent().toggleClass('active');
  $('.faq-ans').not($(this).siblings()).slideUp();
  $(this).siblings().slideToggle();
});
//press slider
$(document).ready(function(){

  $('input[id="checkout"]').click(function(){
    console.log("dfckjghg");
    if($('input[id="checkout"]').is(':checked') == true ){
      //$('.cart__ctas .cart__checkout-button').removeAttr('disabled');
      $('.cart__note').addClass('cart-note-active');
    }else{
      //$('.cart__ctas .cart__checkout-button').attr('disabled','disabled');
      $('.cart__note').removeClass('cart-note-active');
    }
  });
  
  $('#press-slide-block').owlCarousel({
    items:5,
    loop:true,      
    dots: false,
    autoplay:true,
    autoplayTimeout:1200,
    autoplayHoverPause:true,
    speed: 1500,
    nav: false,
    responsive:{
      0:{
        items:3
      },
      600:{
        items:3
      },
      768:{
        items:3
      },
      992:{
        items:3
      },
      1200:{
        items:4
      },
      1300:{
        items:5
      }
    }
  });
  
  
//    $('.Press-logos-block').slick({
//     speed: 1600,
//     autoplay: true,
//     autoplaySpeed: 30,
//     cssEase: 'linear',
//     slidesToShow: 8,
//  	slidesToScroll: 1,
//     infinite: true,
//    	centerMode: true,
//     pauseOnHover:false,
//     focusOnSelect: false,
//      arrows:false,
//     responsive: [
//       {
//         breakpoint: 1460,
//         settings: {
//           slidesToShow: 6,
//         }
//       },
//       {
//         breakpoint: 1025,
//         settings: {
//           slidesToShow: 5,
//         }
//       },
//       {
//         breakpoint: 768,
//         settings: {
//           slidesToShow: 4,
//         }
//       },
//       {
//         breakpoint: 576,
//         settings: {
//           slidesToShow: 4,
//           centerMode: false
//         }
//       },
//       {
//         breakpoint: 480,
//         settings: {
//           slidesToShow: 2,
//         }
//       }
//     ]
//   });
  
  $(".Press-logos-block").slick({speed:3e3,autoplay:!0,autoplaySpeed:0,cssEase:"linear",slidesToShow:8,slidesToScroll:1,infinite:!0,swipeToSlide:!0,centerMode:!0,focusOnSelect:!0,arrows:!1,variableWidth:!0});


  $('.marina-slider').slick({
    arrows: false,
    dots: false,
    infinite: true,
    slidesToShow: 4,
    slidesToScroll: 4,
    autoplay:false,
    autoplaySpeed: 3000,
    speed: 500,
    cssEase: "linear",
    responsive: [
      {
        breakpoint: 1359,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 4
        }
      },          
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          speed: 500,
          cssEase: "linear"
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 2,
          slidesToScroll:2,
          speed: 500,
          cssEase: "linear"
        }
      },
      {
        breakpoint: 360,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
          speed: 500,
          cssEase: "linear"
        }
      }
    ]
  });
  
  //career page faq content
  $('.faq-que-ans .career-faq-que').click(function(){
    $('.career_faq-general').not($(this).parent()).removeClass('active');
    $(this).parent().toggleClass('active');
    $('.career-faq-ans').not($(this).siblings()).slideUp();
    $(this).siblings().slideToggle();
  });
  
  /*-- cooperation page ----*/
    $('.template-page-cooperations .cooperations-tab .cooperations-content a').click(function(){ 
      $('.cooperations-content').removeClass('in-active');
      $(this).parents('.cooperations-content').addClass('in-active');                     
      var coopration_tag= $(this).parents('.cooperations-content').data('tab-title');
      $('.cooperations-subimg .cooperations-main-image').addClass('tag-other-active');
      $('.cooperations-subimg .cooperations-main-image').removeClass('tag-active');
      $('.cooperations-subimg .cooperations-main-image[data-tab-tag="'+coopration_tag+'"]').addClass('tag-active');
    });

    $('#shopify-section-cooperations-tab .heading-main .page-heading').click(function(){
       localStorage.setItem('cooperation_tag', ''); 
      $('.cooperations-content').removeClass('in-active');
      $('.cooperations-subimg .cooperations-main-image').removeClass('tag-other-active');
      $('.cooperations-subimg .cooperations-main-image').removeClass('tag-active');
    });

    $('.cooperations-tab .cooperations-content').click(function(){
      var page_tab = $(this).data('tab-title');
      localStorage.setItem('cooperation_tag', page_tab); 
      var tag_name = localStorage.getItem('cooperation_tag');
    });

    var cooperation_tag = localStorage.getItem('cooperation_tag');
    if(cooperation_tag){ 
      $('.cooperations-tab .cooperations-content[data-tab-title="'+cooperation_tag+'"]').addClass('in-active');       
      $('.cooperations-subimg .cooperations-main-image').addClass('tag-other-active');
      $('.cooperations-subimg .cooperations-main-image').removeClass('tag-active');
      $('.cooperations-subimg .cooperations-main-image[data-tab-tag="'+cooperation_tag+'"]').addClass('tag-active');
    }

    $('.footer-block__details-content li a').click(function(){
      localStorage.setItem('cooperation_tag', ''); 
    });
});


// Chat box
(function() {
  function onTidioChatApiReady() {
    window.tidioChatApi.show();
  }

  if (window.tidioChatApi) {
    window.tidioChatApi.on("ready", onTidioChatApiReady);
  }

  document.querySelector(".message-icon").addEventListener("click", function() {
    window.tidioChatApi.show();
    window.tidioChatApi.open();
  });
})();
